function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".\\33 69f730d-7ad6-415c-9d7d-059d922dedbf{fill:#f7b5bd;}.bd54e5ad-0bee-4fbc-90e2-4f5e7a328d58,.f217f3d6-36a0-4e2b-b8f4-1f103126ddc8{fill:#fb9ca4;}.\\33 eaad8c5-0510-48fa-8a2a-77f71ca4d9f7,.\\38 d7f3a60-86b4-40d0-a6ff-f2d7085c86eb,.ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef,.bd54e5ad-0bee-4fbc-90e2-4f5e7a328d58{opacity:0.1;}.\\33 eaad8c5-0510-48fa-8a2a-77f71ca4d9f7,.\\38 d7f3a60-86b4-40d0-a6ff-f2d7085c86eb,.\\39 a0534a5-8134-4af8-9396-61b61bd0fed3,.\\39 c7d8b42-fb5a-458b-b0f0-54235e3fb4f2,.a3a6c0e6-d53b-4c59-9b05-749ed10b240d,.ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef,.bd54e5ad-0bee-4fbc-90e2-4f5e7a328d58,.c47f4462-64b3-47af-a833-5e5444796067{isolation:isolate;}.\\30 240a6d2-d33a-460c-99cc-0d3a0d7fcade,.\\33 eaad8c5-0510-48fa-8a2a-77f71ca4d9f7,.a3a6c0e6-d53b-4c59-9b05-749ed10b240d{fill:#b1a0bb;}.\\34 9e7d872-cb34-474d-95dd-ff03667a30d7{fill:#fff;}.dda50b30-c05c-471b-8c42-080ccf6b6199{fill:#7a66a3;}.\\39 a0534a5-8134-4af8-9396-61b61bd0fed3,.a3a6c0e6-d53b-4c59-9b05-749ed10b240d,.c47f4462-64b3-47af-a833-5e5444796067{opacity:0.05;}.\\31 afa8d5e-158f-4e63-80d8-9508f26ca744,.\\38 d7f3a60-86b4-40d0-a6ff-f2d7085c86eb,.c47f4462-64b3-47af-a833-5e5444796067{fill:#f2f2f2;stroke:#724279;stroke-miterlimit:10;stroke-width:0.75px;}.de9b19aa-f833-40be-ba57-711fe6902306{fill:#fec2be;}.\\30 d6a080f-2586-440c-ba56-4ba040de1f07{fill:#4c4981;}.f2fde5c9-69d9-4232-8f17-82f65f251de5{fill:#3a3768;}.\\35 fe0dbdb-4c8e-4ca4-9352-df6ba839b747{fill:#9094cb;}.fd634c6f-00c5-402a-b6d3-8be37c083f8b{fill:#fcc5c5;}.f900f23f-ee25-4ff0-bfcd-36b6709d9d9f{fill:#ea3434;}.\\37 1d05a25-099b-474b-9c77-f9119063bf09{fill:#b9bbd6;}.\\34 3cceecd-1668-4665-a83b-4c78a86a4cd0{fill:#927fc6;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "mobile");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "369f730d-7ad6-415c-9d7d-059d922dedbf",
  d: "M57.5,7.8c4.4-3.9,11.2-4.7,17.4-4.4,19.6,1,37.2,10.4,52.5,21.1,5.5,3.9,11,8,14.6,13.4,7.3,10.8,5.1,25.9-5,34.8a51.064,51.064,0,0,1-12,7.4c-7.7,3.7-15.9,6.6-24.6,7.5a82.588,82.588,0,0,1-18.6-.7c-17.2-2.3-34.1-7.5-48.2-16.3C27.4,66.7,21.5,61.9,19,55.7s-1-14.3,5.4-18a30.343,30.343,0,0,1,8.8-2.9c4.5-1,9.1-1.9,13.2-3.8,4.2-2,9.2-5.9,8.4-10.3C53.8,15.9,53.1,11.7,57.5,7.8Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "f217f3d6-36a0-4e2b-b8f4-1f103126ddc8",
  d: "M27.5,101.3s-5.8-.4-5.2,3.7a1,1,0,0,0,.5,1.1s0-.3.6-.2H24a1.135,1.135,0,0,0,.8-.3h0s1.6-.7,2.3-3.4a4.233,4.233,0,0,0,.5-.7l-1,.4a1.95,1.95,0,0,1,.1,1.3s0-1.3-.2-1.2l-.5.2a2.57,2.57,0,0,1,.1,2.1s.2-1.5-.3-2.1l-.7.4a2.678,2.678,0,0,1,.2,2.3,3.365,3.365,0,0,0-.4-2.2l-.6.5a3.073,3.073,0,0,1,.2,2.1s-.1-1.9-.4-2c-.2.2-.5.4-.6.7a2.386,2.386,0,0,1,.2,1.4,5.274,5.274,0,0,0-.3-1.2,3.506,3.506,0,0,0-.6,1.4,2.976,2.976,0,0,1,.5-1.5,2.01,2.01,0,0,0-.8.4s.1-.6,1-.6c.2-.2.4-.5.6-.7a3.178,3.178,0,0,0-1.4.2,1.525,1.525,0,0,1,1.6-.3l.6-.5a4.854,4.854,0,0,0-1.7,0,1.92,1.92,0,0,1,1.8-.1l.7-.4a4.329,4.329,0,0,0-1.6-.1,2.775,2.775,0,0,1,1.8,0l.5-.2a5.073,5.073,0,0,1-.9-.2l-.2-.1a2.3,2.3,0,0,1,1.4.2A5.935,5.935,0,0,1,27.5,101.3Z"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  className: "bd54e5ad-0bee-4fbc-90e2-4f5e7a328d58",
  cx: 23.5,
  cy: 106.4,
  rx: 4.1,
  ry: 0.7
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "f217f3d6-36a0-4e2b-b8f4-1f103126ddc8",
  d: "M38.8,90.5s-3.3-.2-2.9,2.1a.713.713,0,0,0,.3.6s0-.2.3-.1h.4a.52.52,0,0,0,.4-.2h0A2.585,2.585,0,0,0,38.6,91s.3-.3.3-.4l-.6.2a.854.854,0,0,1,0,.7s0-.7-.1-.7l-.3.1a1.672,1.672,0,0,1,.1,1.2s.1-.9-.2-1.2l-.4.2a1.5,1.5,0,0,1,.1,1.3,2.953,2.953,0,0,0-.2-1.3l-.3.5a1.672,1.672,0,0,1,.1,1.2s0-1.1-.2-1.1c-.1.1-.3.2-.4.4a1.506,1.506,0,0,1,.1.8s-.1-.7-.2-.7a1.135,1.135,0,0,0-.3.8,1.136,1.136,0,0,1,.3-.8c-.2,0-.3.1-.5.2,0,0,0-.3.6-.4.1-.1.2-.3.3-.4a2.2,2.2,0,0,0-.8.1.959.959,0,0,1,.9-.2l.3-.3h-.9a1.183,1.183,0,0,1,1-.1l.4-.2a2.769,2.769,0,0,0-.9-.1,1.7,1.7,0,0,1,1,0l.3-.1a4.331,4.331,0,0,0-.5-.1h-.1a2.2,2.2,0,0,1,.8.1A1.69,1.69,0,0,0,38.8,90.5Z"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  className: "bd54e5ad-0bee-4fbc-90e2-4f5e7a328d58",
  cx: 36.5,
  cy: 93.4,
  rx: 2.3,
  ry: 0.4
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "f217f3d6-36a0-4e2b-b8f4-1f103126ddc8",
  d: "M19.3,92.5s-4-.2-3.5,2.5a.67.67,0,0,0,.4.7s0-.2.4-.1H17a.764.764,0,0,0,.5-.2h0a3.508,3.508,0,0,0,1.6-2.3,2.186,2.186,0,0,0,.3-.5l-.7.3a1.387,1.387,0,0,1,0,.9s0-.9-.2-.8l-.3.2a1.962,1.962,0,0,1,.1,1.5,2.673,2.673,0,0,0-.2-1.4l-.5.3a1.81,1.81,0,0,1,.1,1.6,2.622,2.622,0,0,0-.2-1.5l-.4.3a2.3,2.3,0,0,1,.2,1.4s0-1.3-.3-1.4a1,1,0,0,0-.4.5,1.35,1.35,0,0,1,.1,1,3.711,3.711,0,0,0-.2-.9,3.552,3.552,0,0,0-.4.9,1.689,1.689,0,0,1,.3-1,.864.864,0,0,0-.6.3s.1-.4.7-.4a1.756,1.756,0,0,1,.4-.5,3.4,3.4,0,0,0-1,.1,1.09,1.09,0,0,1,1.1-.2l.4-.3a2.045,2.045,0,0,0-1.1,0,1.287,1.287,0,0,1,1.2-.1l.5-.3a4.1,4.1,0,0,0-1.1-.1,2.438,2.438,0,0,1,1.2,0l.3-.1s-.5-.1-.6-.1a.349.349,0,0,1-.2-.1,1.412,1.412,0,0,1,.9.1A6.891,6.891,0,0,0,19.3,92.5Z"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  className: "bd54e5ad-0bee-4fbc-90e2-4f5e7a328d58",
  cx: 16.6,
  cy: 96,
  rx: 2.8,
  ry: 0.5
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M72.6,91.6a1.794,1.794,0,0,1,.7.5,2.705,2.705,0,0,0,2.3,1.5c1.6,0,2.9-1.7,2.9-3.8S77.2,86,75.6,86a2.61,2.61,0,0,0-2,1,2.177,2.177,0,0,0-.5.8V88a1.36,1.36,0,0,1-1.5,0V75.7h-12a.972.972,0,0,1-.1-.9,1.794,1.794,0,0,1,.5-.7,2.705,2.705,0,0,0,1.5-2.3c0-1.6-1.7-2.9-3.8-2.9s-3.7,1.4-3.7,3a2.61,2.61,0,0,0,1,2,2.177,2.177,0,0,0,.8.5h0a1.075,1.075,0,0,1,.2,1.4H53.2V98.4a3.329,3.329,0,0,0,3.3,3.3H71.7V91.8A.959.959,0,0,1,72.6,91.6Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M53.5,72.3A4.233,4.233,0,0,1,58,68.4a4.278,4.278,0,0,1,3.9,3.9,3.838,3.838,0,0,1-1.5,3H71.7V63.1a1.163,1.163,0,0,1,1-.2,1.794,1.794,0,0,1,.7.5,2.705,2.705,0,0,0,2.3,1.5c1.6,0,2.9-1.7,2.9-3.8s-1.3-3.8-2.9-3.8a2.61,2.61,0,0,0-2,1,2.177,2.177,0,0,0-.5.8h0a1.212,1.212,0,0,1-1.5.2V47H60.1a.972.972,0,0,1-.1-.9,1.794,1.794,0,0,1,.5-.7A2.705,2.705,0,0,0,62,43.1c0-1.6-1.7-2.9-3.8-2.9s-3.8,1.3-3.8,2.9a2.61,2.61,0,0,0,1,2,2.177,2.177,0,0,0,.8.5h0a1.075,1.075,0,0,1,.2,1.4H53.1V75.2H55A3.8,3.8,0,0,1,53.5,72.3Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M54,43.4a4.233,4.233,0,0,1,4.5-3.9,4.278,4.278,0,0,1,3.9,3.9,3.838,3.838,0,0,1-1.5,3H71.6V34.1a1.163,1.163,0,0,1,1-.2,1.794,1.794,0,0,1,.7.5,2.705,2.705,0,0,0,2.3,1.5c1.6,0,2.9-1.7,2.9-3.8s-1.3-3.8-2.9-3.8a2.61,2.61,0,0,0-2,1,2.177,2.177,0,0,0-.5.8v.2a1.36,1.36,0,0,1-1.5,0V24.4H63.7A2.689,2.689,0,0,1,61,21.7v-.6H56.5a3.329,3.329,0,0,0-3.3,3.3h0v22h2.4A3.95,3.95,0,0,1,54,43.4Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M92.7,38.1v8.2h.9V37.8h-.5C92.9,37.8,92.8,37.9,92.7,38.1Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M93.9,38.1h-.3v8.2h.6V38.4a.451.451,0,0,0-.3-.3Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M75.8,27.8a4.233,4.233,0,0,1,3.9,4.5,4.115,4.115,0,0,1-3.9,3.9,3.838,3.838,0,0,1-3-1.5V46.4H85.4a3.838,3.838,0,0,1-1.5-3,4.1,4.1,0,0,1,4.2-3.9,4.779,4.779,0,0,1,2.8,1V24.4a3.329,3.329,0,0,0-3.3-3.3H82.9v.6a2.689,2.689,0,0,1-2.7,2.7H72.8v5A3.8,3.8,0,0,1,75.8,27.8Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M56.5,101.6a3.329,3.329,0,0,1-3.3-3.3h0V75.7H50.6V98.5a5.378,5.378,0,0,0,5.4,5.4H71.7v-2.2H56.5Z"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  x: 50.1,
  y: 46.3,
  width: 0.4,
  height: 0.7
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  x: 50.9,
  y: 46.3,
  width: 2.2,
  height: 0.7
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  x: 50.5,
  y: 46.3,
  width: 0.3,
  height: 0.7
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M50.4,50.2h0l.1-3.2h-.4v2.9a.265.265,0,0,0,.3.3Z"
});

var _ref22 = /*#__PURE__*/React.createElement("image", {
  className: "9c7d8b42-fb5a-458b-b0f0-54235e3fb4f2",
  width: 4,
  height: 30,
  transform: "translate(50 46)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAeCAYAAAALvL+DAAAACXBIWXMAAAsSAAALEgHS3X78AAAAFElEQVQYV2PYuGD3f2TMMCowcgQAlO9tOC6mU+YAAAAASUVORK5CYII="
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M50.5,50.2h0a.265.265,0,0,0,.3-.3h0V47h-.3Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M50.9,44.6a.265.265,0,0,0-.3-.3h0v2.1h.3Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M50.6,30.1h0c-.2,0-.4.1-.4.3h0v2.8a.265.265,0,0,0,.3.3h.1V30.1Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M50.5,36.3a.265.265,0,0,0-.3.3v5.3a.265.265,0,0,0,.3.3h.1V36.3Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M50.6,44.3h0c-.3,0-.4.1-.4.3h0v1.7h.4Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M50.6,24.2V30a.265.265,0,0,1,.3.3v2.8a.265.265,0,0,1-.3.3v2.8h0a.265.265,0,0,1,.3.3h0v5.3a.265.265,0,0,1-.3.3h-.1v2.1h0a.265.265,0,0,1,.3.3v1.7H53v-22a3.329,3.329,0,0,1,3.3-3.3H61v.6a2.689,2.689,0,0,0,2.7,2.7h7.9V22.4H68a.472.472,0,0,1-.5-.5v-.1a.472.472,0,0,1,.5-.5h3.6V18.7H56A5.666,5.666,0,0,0,50.6,24.2Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M50.9,33.2V30.4a.265.265,0,0,0-.3-.3v3.4A.319.319,0,0,0,50.9,33.2Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M51,41.9V36.6a.265.265,0,0,0-.3-.3h-.1v5.9h0c.2,0,.4-.1.4-.3Z"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  x: 72.8,
  y: 18.8,
  width: 1.1,
  height: 2.5
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  x: 72.8,
  y: 22.5,
  width: 1.1,
  height: 1.8
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M73.9,21.3c.3.1.6.6.6.6V22s-.3.5-.6.5h0v1.8h6.3a2.689,2.689,0,0,0,2.7-2.7V21h4.7a3.329,3.329,0,0,1,3.3,3.3V40.4a3.679,3.679,0,0,1,.6,5.2l-.6.6v.1h1.9V38.2h.7V24a5.164,5.164,0,0,0-5.2-5.2H73.8v2.5Zm2.1,0a.7.7,0,1,1-.7.7h0a.684.684,0,0,1,.7-.7Z"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  x: 90,
  y: 75.1,
  width: 2.6,
  height: 0.6
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M92.6,75.7V98.4a5.378,5.378,0,0,1-5.4,5.4H72.7v-2.2h14A3.329,3.329,0,0,0,90,98.3h0V75.7Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M90.3,71.9a3.255,3.255,0,0,0-.4-1.4v2.7A2.5,2.5,0,0,0,90.3,71.9Z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M88.3,74.9a1.794,1.794,0,0,1,.5-.7,2.932,2.932,0,0,0,1-.9V70.6a3.971,3.971,0,0,0-3.3-1.5c-2.1,0-3.8,1.3-3.8,2.9a2.61,2.61,0,0,0,1,2,2.177,2.177,0,0,0,.8.5h0a1.075,1.075,0,0,1,.2,1.4H72.5V87.2a3.564,3.564,0,0,1,3-1.5,4.233,4.233,0,0,1,3.9,4.5,4.278,4.278,0,0,1-3.9,3.9,3.838,3.838,0,0,1-3-1.5v9.2h14a3.329,3.329,0,0,0,3.3-3.3V75.8H88.4A.972.972,0,0,1,88.3,74.9Z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M73.9,90.4a1.794,1.794,0,0,1,.7.5,2.705,2.705,0,0,0,2.3,1.5c1.6,0,2.9-1.7,2.9-3.8s-1.3-3.8-2.9-3.8a2.61,2.61,0,0,0-2,1,2.177,2.177,0,0,0-.5.8v.2a1.36,1.36,0,0,1-1.5,0V74.6h-12a.972.972,0,0,1-.1-.9,1.794,1.794,0,0,1,.5-.7,2.705,2.705,0,0,0,1.5-2.3c0-1.6-1.7-2.9-3.8-2.9s-3.8,1.3-3.8,2.9a2.61,2.61,0,0,0,1,2,2.177,2.177,0,0,0,.8.5h0a1.075,1.075,0,0,1,.2,1.4H54.4V97.2a3.329,3.329,0,0,0,3.3,3.3H72.9V90.6A1.232,1.232,0,0,1,73.9,90.4Z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M54.8,71.1a4.233,4.233,0,0,1,4.5-3.9,4.278,4.278,0,0,1,3.9,3.9,3.838,3.838,0,0,1-1.5,3H73V61.9a1.163,1.163,0,0,1,1-.2,1.794,1.794,0,0,1,.7.5A2.705,2.705,0,0,0,77,63.7c1.6,0,2.9-1.7,2.9-3.8s-1.3-3.8-2.9-3.8a2.61,2.61,0,0,0-2,1,2.177,2.177,0,0,0-.5.8h0a1.212,1.212,0,0,1-1.5.2V45.9H61.4a.972.972,0,0,1-.1-.9,1.794,1.794,0,0,1,.5-.7A2.705,2.705,0,0,0,63.3,42c0-1.6-1.7-2.9-3.8-2.9s-3.8,1.3-3.8,2.9a2.61,2.61,0,0,0,1,2,2.177,2.177,0,0,0,.8.5h0a1.075,1.075,0,0,1,.2,1.4H54.4V74.1h1.9A3.833,3.833,0,0,1,54.8,71.1Z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M55.3,42.2a4.233,4.233,0,0,1,4.5-3.9,4.278,4.278,0,0,1,3.9,3.9,3.838,3.838,0,0,1-1.5,3H72.9V32.9a1.163,1.163,0,0,1,1-.2,1.794,1.794,0,0,1,.7.5,2.705,2.705,0,0,0,2.3,1.5c1.6,0,2.9-1.7,2.9-3.8s-1.3-3.8-2.9-3.8a2.61,2.61,0,0,0-2,1,2.177,2.177,0,0,0-.5.8v.2a1.36,1.36,0,0,1-1.5,0V23.2H65a2.689,2.689,0,0,1-2.7-2.7v-.6H57.8a3.329,3.329,0,0,0-3.3,3.3h0v22h2.4A3.665,3.665,0,0,1,55.3,42.2Z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M94,36.9v8.2h.9V36.6h-.5C94.2,36.6,94,36.7,94,36.9Z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M95.1,36.9h-.3v8.2h.6V37.2A.319.319,0,0,0,95.1,36.9Z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M77.1,26.6A4.233,4.233,0,0,1,81,31.1,4.115,4.115,0,0,1,77.1,35a3.838,3.838,0,0,1-3-1.5V45.2H86.7a3.838,3.838,0,0,1-1.5-3,4.1,4.1,0,0,1,4.2-3.9,4.779,4.779,0,0,1,2.8,1V23.2a3.329,3.329,0,0,0-3.3-3.3H84.2v.6a2.689,2.689,0,0,1-2.7,2.7H74.1v5A3.657,3.657,0,0,1,77.1,26.6Z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M57.8,100.4a3.329,3.329,0,0,1-3.3-3.3h0V74.5H51.9V97.3a5.378,5.378,0,0,0,5.4,5.4H73v-2.2Z"
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  x: 51.4,
  y: 45.1,
  width: 0.4,
  height: 0.7
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  x: 52.1,
  y: 45.1,
  width: 2.2,
  height: 0.7
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  x: 51.8,
  y: 45.1,
  width: 0.3,
  height: 0.7
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M51.7,49h0l.1-3.2h-.4v2.9a.265.265,0,0,0,.3.3Z"
});

var _ref49 = /*#__PURE__*/React.createElement("image", {
  className: "9c7d8b42-fb5a-458b-b0f0-54235e3fb4f2",
  width: 4,
  height: 29,
  transform: "translate(51 45)",
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAdCAYAAACNKM0tAAAACXBIWXMAAAsSAAALEgHS3X78AAAAHElEQVQYV2P4//8/Q1Xa4v8wzIAhgMwZFRjKAgCahSPu5EOUrgAAAABJRU5ErkJggg=="
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M51.8,49h0a.265.265,0,0,0,.3-.3h0V45.8h-.3Z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M52.2,43.4a.265.265,0,0,0-.3-.3h0v2.1h.3Z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M51.9,28.9h0c-.2,0-.4.1-.4.3h0V32a.265.265,0,0,0,.3.3h.1V28.9Z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M51.8,35.1a.265.265,0,0,0-.3.3v5.3a.265.265,0,0,0,.3.3h.1V35.1Z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M51.9,43.1h0c-.3,0-.4.1-.4.3h0v1.7h.4Z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M51.9,23.1v5.8a.265.265,0,0,1,.3.3V32a.265.265,0,0,1-.3.3v2.8h0a.265.265,0,0,1,.3.3h0v5.3a.265.265,0,0,1-.3.3h-.1v2.1h0a.265.265,0,0,1,.3.3v1.7h2.2v-22a3.329,3.329,0,0,1,3.3-3.3h4.5v.6a2.689,2.689,0,0,0,2.7,2.7H73V21.3H69.3a.472.472,0,0,1-.5-.5v-.1a.472.472,0,0,1,.5-.5H73V17.6H57.3A5.529,5.529,0,0,0,51.9,23.1Z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M52.2,32V29.2a.265.265,0,0,0-.3-.3v3.4A.319.319,0,0,0,52.2,32Z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M52.2,40.7V35.4a.265.265,0,0,0-.3-.3h-.1V41h0c.3,0,.4-.1.4-.3Z"
});

var _ref58 = /*#__PURE__*/React.createElement("rect", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  x: 74.1,
  y: 17.6,
  width: 1.1,
  height: 2.5
});

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  x: 74.1,
  y: 21.3,
  width: 1.1,
  height: 1.8
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M75.2,20.1c.3.1.6.6.6.6v.1s-.3.5-.6.5h0v1.8h6.3a2.689,2.689,0,0,0,2.7-2.7v-.6h4.7a3.329,3.329,0,0,1,3.3,3.3V39.2a3.679,3.679,0,0,1,.6,5.2l-.6.6v.1h1.9V37h.7V22.8a5.164,5.164,0,0,0-5.2-5.2H75v2.5Zm2.1,0a.7.7,0,1,1-.7.7h0a.684.684,0,0,1,.7-.7Z"
});

var _ref61 = /*#__PURE__*/React.createElement("rect", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  x: 91.3,
  y: 73.9,
  width: 2.6,
  height: 0.6
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M93.9,74.5V97.2a5.378,5.378,0,0,1-5.4,5.4H73.9v-2.2h14a3.329,3.329,0,0,0,3.3-3.3h0V74.5Z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M91.6,70.7a3.255,3.255,0,0,0-.4-1.4V72A2.5,2.5,0,0,0,91.6,70.7Z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M89.5,73.7A1.794,1.794,0,0,1,90,73a2.932,2.932,0,0,0,1-.9V69.4a4.037,4.037,0,0,0-3.4-1.5c-2.1,0-3.8,1.3-3.8,2.9a2.61,2.61,0,0,0,1,2,2.177,2.177,0,0,0,.8.5h0a1.075,1.075,0,0,1,.2,1.4h-12V86a3.838,3.838,0,0,1,3-1.5A4.233,4.233,0,0,1,80.7,89a4.278,4.278,0,0,1-3.9,3.9,3.838,3.838,0,0,1-3-1.5v9.2h14a3.329,3.329,0,0,0,3.3-3.3V74.6H89.7A1.02,1.02,0,0,1,89.5,73.7Z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M103.9,54.9a20.706,20.706,0,0,0,5,.5h.6l.8-1.5-.8-1.3s-.7-.2-1.6-.4c-1.4-.2-3.2-.4-4.1.1C102.2,53.3,102.4,54.4,103.9,54.9Z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "3eaad8c5-0510-48fa-8a2a-77f71ca4d9f7",
  d: "M108.9,55.4h.6l.8-1.5-.8-1.3s-.7-.2-1.6-.4C108.6,52.8,110.4,54,108.9,55.4Z"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M121.3,36.6l-.3-.4a18.507,18.507,0,0,0-1.9,3.7c-.2,1-.4,2.2-.4,2.2A17.34,17.34,0,0,1,118,44c-.2.4-.4.9-.6,1.4a1.374,1.374,0,0,1-.4,1.2,2.389,2.389,0,0,0-.7,1.3s-1.9,1.9-3,1.9-4,.6-3.9,1.1-1.2.8-1.8.9,3.5,1.7,1.1,3.6c0,0,1.5.3,1.6.7s1.7-.2,1.7-.2a1.562,1.562,0,0,1,1.5-.8,2.523,2.523,0,0,0,1.7-.6,6.079,6.079,0,0,1,1.8-.9,12.684,12.684,0,0,0,1.5-.4c0-.1,3.8-16.6,3.8-16.6Z"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "a3a6c0e6-d53b-4c59-9b05-749ed10b240d",
  d: "M121.3,36.6l-.3-.4a18.507,18.507,0,0,0-1.9,3.7c-.2,1-.4,2.2-.4,2.2A17.34,17.34,0,0,1,118,44c-.2.4-.4.9-.6,1.4a1.374,1.374,0,0,1-.4,1.2,2.389,2.389,0,0,0-.7,1.3s-1.9,1.9-3,1.9-4,.6-3.9,1.1-1.2.8-1.8.9,3.5,1.7,1.1,3.6c0,0,1.5.3,1.6.7s1.7-.2,1.7-.2a1.562,1.562,0,0,1,1.5-.8,2.523,2.523,0,0,0,1.7-.6,6.079,6.079,0,0,1,1.8-.9,12.684,12.684,0,0,0,1.5-.4c0-.1,3.8-16.6,3.8-16.6Z"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M129.9,103.1a18.289,18.289,0,0,0-.6,2.5s-.6,2.6-4,1.9c0,0-2.3-.1-2.1-.9a2.614,2.614,0,0,1,.3-.8c.1-.2.2-.3.2-.5s.5-.7.6-1.1.2-.9.3-1.3a10.408,10.408,0,0,1,.6-2.2,5.637,5.637,0,0,1,.4-1.2l3.9,1s-.2,1,0,1.3a3.7,3.7,0,0,1,.5,1.1A.31.31,0,0,0,129.9,103.1Z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M113.3,81.2a18.873,18.873,0,0,1,.9,3.4,2.663,2.663,0,0,1,.3,1.2,4.012,4.012,0,0,0,.3,1.5l1.1,4a2.885,2.885,0,0,0,.3,1.8c.4.7.4.5.2,1.8a2.848,2.848,0,0,0,.9,2.9c.7.4-.3,1.3-.3,1.3s4.4,1.2,5.3.5-.5-4.3-.5-4.3c.1-1.2.1-2.3.1-3.5-.2-.4-.8-4.2-.8-4.2a4.567,4.567,0,0,1-.2-2c.2-.3-.1-1.1-.1-1.1s-.7-.9-.6-1.2a1.884,1.884,0,0,0-.2-.8s2-3,1.8-3.6a2.573,2.573,0,0,1,.1-1.5l.5-.9c.4-.6.8-1.4,1-1.6.3-.7.6-1.5.9-2.3l.2-.5a62,62,0,0,0,.6,6.2c.3,1.7.5,3.4.7,5.1a5.067,5.067,0,0,1,.2,1.3,25.009,25.009,0,0,0,.6,3.8,12.892,12.892,0,0,1,.1,2.8,38.438,38.438,0,0,0,0,4.8,4.708,4.708,0,0,0-1.3,1.5,9.638,9.638,0,0,0,0,2.4s3.1,1.5,4.4,1.1.8-2.7.8-2.7a9.494,9.494,0,0,0,.9-2.1l.3-2.4c1.2-2.1.7-7.4.9-7.8s-.4-2-.9-2.7a4.417,4.417,0,0,1,0-3.2c.3-.6-.3-2.5-.3-2.5a36.694,36.694,0,0,0,.5-4.3,18.917,18.917,0,0,1,.5-2.3s.5-.9.4-1.2.4-1,.2-1.3a3.922,3.922,0,0,1,.4-1.8,11.626,11.626,0,0,0,.4-1.8c.1-.7.2-1.2.2-1.2l-3.2-2.6L123,59.1l-3-1-2.9,4.6c-.2.3-.4.7-.6,1a3.259,3.259,0,0,0-.4,1.3,1.8,1.8,0,0,1-.3,1.2s-1.7,5.5-1.7,7a40.2,40.2,0,0,1-.6,5C113.6,78.4,112.9,80.6,113.3,81.2Z"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M125,36.7a4.773,4.773,0,0,0,1.1-4.4c0-.1,0-.1-.1-.2h-.3a4.7,4.7,0,0,1-4.7-4.7h0a5.853,5.853,0,0,1,.2-1.3,4.684,4.684,0,1,1,9,2.6c0,.1,0,.1-.1.2V29c.6,1.4,1.4,3.1,2.1,3.5C133.4,33.2,125.1,36.7,125,36.7Z"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M116.3,63.3a2.851,2.851,0,0,1,.8,1.4s2.3,1.6,2.1.6,1.2-5,1.2-5l-.2,5.5s7.4-.3,7.9-.9a17.252,17.252,0,0,1,3.7-1.6s2.7,2.2,3.2,2-.9-3.9-.9-3.9l-1.4-21.8s.4-6.5-.2-6.7a.215.215,0,0,1-.2-.2,2.353,2.353,0,0,1-.5-1.6c0-.7-1-.3-1-.3l.5.7-4.8,2.9h0l-.6-.3a2,2,0,0,0-1.3-.2,1.205,1.205,0,0,0-.5.5,3.1,3.1,0,0,0-.6,1.3l-1.7,2.9s-.9,3.9-.9,4a19.335,19.335,0,0,1-.6,4.1,5.759,5.759,0,0,0-.5,2.9,12.288,12.288,0,0,1-.2,2.7c-1.3,1-1.9,4.6-1.9,4.6l-2.2,4.4A2.319,2.319,0,0,0,116.3,63.3Z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  className: "3eaad8c5-0510-48fa-8a2a-77f71ca4d9f7",
  d: "M126.7,34.5a9.763,9.763,0,0,0,1.8,1.7l3.9-3.3a2.353,2.353,0,0,1-.5-1.6c0-.7-1-.3-1-.3l.1.1a.633.633,0,0,1-.1.9h-.1Z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M126.7,34.4a9.763,9.763,0,0,0,1.8,1.7l3.9-3.3a2.353,2.353,0,0,1-.5-1.6c0-.7-1-.3-1-.3l.1.1a.633.633,0,0,1-.1.9h-.1Z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  className: "3eaad8c5-0510-48fa-8a2a-77f71ca4d9f7",
  d: "M124.9,34.9c.5.6,1.2,1.3,1.2.9a3.694,3.694,0,0,1,.7-1.4,3.3,3.3,0,0,0-1.4,0A1.205,1.205,0,0,0,124.9,34.9Z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M124.8,34.7c.5.6,1.2,1.3,1.2.9a2.134,2.134,0,0,1,.7-1.2,2,2,0,0,0-1.3-.2A1.024,1.024,0,0,0,124.8,34.7Z"
});

var _ref77 = /*#__PURE__*/React.createElement("circle", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  cx: 126.1,
  cy: 37.6,
  r: 0.3
});

var _ref78 = /*#__PURE__*/React.createElement("circle", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  cx: 123.8,
  cy: 45.8,
  r: 0.3
});

var _ref79 = /*#__PURE__*/React.createElement("circle", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  cx: 121.1,
  cy: 54.2,
  r: 0.3
});

var _ref80 = /*#__PURE__*/React.createElement("circle", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  cx: 121,
  cy: 63.4,
  r: 0.3
});

var _ref81 = /*#__PURE__*/React.createElement("circle", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  cx: 124.7,
  cy: 41.5,
  r: 0.3
});

var _ref82 = /*#__PURE__*/React.createElement("circle", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  cx: 122.7,
  cy: 50,
  r: 0.3
});

var _ref83 = /*#__PURE__*/React.createElement("circle", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  cx: 120.6,
  cy: 58.4,
  r: 0.3
});

var _ref84 = /*#__PURE__*/React.createElement("circle", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  cx: 121.1,
  cy: 64.4,
  r: 0.3
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  className: "3eaad8c5-0510-48fa-8a2a-77f71ca4d9f7",
  d: "M132.4,32.9s-.1-.5.6.3a8.961,8.961,0,0,0,1.9,1.5s2.8,2,3,2.9,1.1,4.9.6,6.2-4.2,7.7-4.2,7.7A3.223,3.223,0,0,1,135,54a14.723,14.723,0,0,0-.4,3.6c.1.4-.2,1.4.3,1.8s.9,1-.5,1.8c0,0-.3.7,0,.8s-3.4,1.7-4.8.9-4-7.6-4.1-9.1a33.531,33.531,0,0,1,1.3-7.7c.5-1.2,1.8-5.8,2.4-6.8S132.4,32.9,132.4,32.9Z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M132.6,32.9s-.1-.5.6.3a8.961,8.961,0,0,0,1.9,1.5s2.8,2,3,2.9,1.1,4.9.6,6.2-4.2,7.7-4.2,7.7a3.223,3.223,0,0,1,.7,2.5,14.723,14.723,0,0,0-.4,3.6c.1.4-.2,1.4.3,1.8s.9,1-.5,1.8c0,0-.3.7,0,.8s-3.4,1.7-4.8.9-4-7.6-4.1-9.1a33.531,33.531,0,0,1,1.3-7.7c.5-1.2,1.8-5.8,2.4-6.8S132.6,32.9,132.6,32.9Z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  className: "3eaad8c5-0510-48fa-8a2a-77f71ca4d9f7",
  d: "M126.2,33.8s-1.4-.9-3.2,1.4c0,0-1.3.7-1.7.9s-.8,4.9-.8,4.9a8.662,8.662,0,0,0-.6,3.2c.2,1.2-.7,5.2-.7,5.2s-1.5,7.3-1.4,7.5a7.343,7.343,0,0,0,1.5-3.5,19.776,19.776,0,0,1,1.4-5.3c.2-.2,1.4-6.8,1.4-6.8a24.3,24.3,0,0,1,1.6-3.7,29.243,29.243,0,0,1,1.8-3,2.177,2.177,0,0,1,.8-.5Z"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M126.2,33.8s-1.6-.9-3.4,1.4c0,0-1.3.7-1.7.9s-.8,4.9-.8,4.9a8.662,8.662,0,0,0-.6,3.2c.2,1.2-.7,5.2-.7,5.2s-1.5,7.3-1.4,7.5a7.343,7.343,0,0,0,1.5-3.5,19.776,19.776,0,0,1,1.4-5.3c.2-.2,1.4-6.8,1.4-6.8a24.3,24.3,0,0,1,1.6-3.7,29.243,29.243,0,0,1,1.8-3,4.053,4.053,0,0,1,.9-.5Z"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M119.1,49.8s-3-2-4.5-1-3.9,2.4-1.5,3.4a15.218,15.218,0,0,0,5.6.8Z"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M122.5,103.7a22.542,22.542,0,0,1-3.6.6s-2.7.8-3.9,1-4,.1-4.2-.7a1.949,1.949,0,0,1-.1-.8,1.02,1.02,0,0,1,.5-.8,22.5,22.5,0,0,1,2.4-.8s1.3-.3,1.4-.8,1.9-2.1,1.9-2.1.2-1.1.5-1a2.41,2.41,0,0,1,1,1c.1.4,4.1-.4,4.1-.4a4.329,4.329,0,0,0,.1,1.6,5.462,5.462,0,0,1,.1,1.8v.1S123.3,103.3,122.5,103.7Z"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  className: "3eaad8c5-0510-48fa-8a2a-77f71ca4d9f7",
  d: "M121.2,26.2c.1,0,.1.1.2.1a1.689,1.689,0,0,0,1-.3c.3-.2.8-.3,1-.1.4.3.1,1,.5,1.3.2.2.6.1.9.3a1.235,1.235,0,0,1,.4.8c.1.3.2.7.5.8s.6-.1.9-.1h.2v-.1a4.1,4.1,0,0,1,.1-1.1.969.969,0,0,1,.8-.7c.5-.1,1,.4,1.3.8l.9,1.5v.1a4.7,4.7,0,0,0-8.6-3.8c.1.1,0,.3-.1.5Z"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M129.1,27.8c-.3-.4-.8-.9-1.3-.8a1.143,1.143,0,0,0-.8.7,4.1,4.1,0,0,0-.1,1.1v.1h-.2c-.3,0-.6.2-.9.1s-.4-.4-.5-.8a1.234,1.234,0,0,0-.4-.8c-.3-.2-.6-.1-.9-.3-.4-.3-.1-1-.5-1.3-.3-.3-.7-.1-1,.1a1.314,1.314,0,0,1-1,.3c-.1,0-.2-.1-.3-.1-.6-.2-1.3.2-1.8-.2a2.092,2.092,0,0,1-.4-.6c-.1-.3-.2-.6-.3-1a1.929,1.929,0,0,1,.3-1c.3-.4.8-.4,1.2-.7a3.45,3.45,0,0,0,.8-.9,1.765,1.765,0,0,1,.8-.9,1.09,1.09,0,0,1,1.1-.2c.1.1.2.1.4.2a.6.6,0,0,0,.4-.1,7.909,7.909,0,0,1,4.3-.3,4.711,4.711,0,0,1,1.7.4,2.211,2.211,0,0,1,1.2,1.3,6.753,6.753,0,0,0,.2,1.4c.1.3.3.6.4.9a4.234,4.234,0,0,1-.2,2.5,8.675,8.675,0,0,1-.5,2.8c-.1.2-.2.5-.4.4-.1-.1-.3-.6-.4-.7A7.579,7.579,0,0,0,129.1,27.8Z"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  className: "3eaad8c5-0510-48fa-8a2a-77f71ca4d9f7",
  d: "M137.5,42.8l.7,2s-1.6,6.1-2.4,7.4-1.9,2.9-1.9,2.9a6.45,6.45,0,0,1-4.1.5c-2.2-.4-8.6-1.6-8.6-1.6a.829.829,0,0,1-.8-.3c-.3-.4-1.7-.6-1.7-.6s-1.7-2.5.4-3.5c0,0,.3.6,1.4.2s1.4.3,1.4.3a8.834,8.834,0,0,0,2.8.2c1.3-.1,2.5-.2,3.7-.4a.446.446,0,0,1,.5,0,2.177,2.177,0,0,0,.8-.5c.2-.2.5.3.5.3s.4-.2.3-.5.3-1.2.3-1.2a4.868,4.868,0,0,0,.1-1.2,10.548,10.548,0,0,1,.6-2.4,2.768,2.768,0,0,0-.1-.9c-.1-.5,1-1.4,1-1.4s1.1-5.2,3.4-3.5A5.366,5.366,0,0,1,137.5,42.8Z"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M137.6,41.8l.7,2.3s-1.6,7-2.4,8.5S134,56,134,56a5.889,5.889,0,0,1-4.1.6c-2.2-.5-8.6-1.8-8.6-1.8a.735.735,0,0,1-.8-.4c-.3-.5-1.7-.7-1.7-.7s-1.7-2.8.4-4c0,0,.3.6,1.4.2s1.4.4,1.4.4a13.329,13.329,0,0,0,2.8.3c1.3-.1,2.5-.2,3.7-.4a.3.3,0,0,1,.4,0h0a2.177,2.177,0,0,0,.8-.5c.2-.3.5.3.5.3s.4-.2.3-.5a3.194,3.194,0,0,1,.3-1.4,5.7,5.7,0,0,0,.1-1.3,13.1,13.1,0,0,1,.6-2.7,4.1,4.1,0,0,0-.1-1.1c-.1-.5,1-1.6,1-1.6s1.1-6,3.4-4A4.674,4.674,0,0,1,137.6,41.8Z"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  className: "3eaad8c5-0510-48fa-8a2a-77f71ca4d9f7",
  d: "M128.6,50.6s.2,1.8,1.4,2.3S128.6,50.6,128.6,50.6Z"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  className: "3eaad8c5-0510-48fa-8a2a-77f71ca4d9f7",
  d: "M131.2,50c.1,0,1.8.9,1,1.5S131.2,50,131.2,50Z"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  className: "3eaad8c5-0510-48fa-8a2a-77f71ca4d9f7",
  d: "M131.3,48.7s2.5.5,1.7.9S131.3,48.7,131.3,48.7Z"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M105.4,54.1a20.706,20.706,0,0,0,5,.5h.6l.8-1.5-.8-1.3s-.7-.2-1.6-.4c-1.4-.2-3.2-.4-4.1.1C103.8,52.5,104,53.6,105.4,54.1Z"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  className: "8d7f3a60-86b4-40d0-a6ff-f2d7085c86eb",
  d: "M110.4,54.6h.6l.8-1.5-.8-1.3s-.7-.2-1.6-.4C110.1,52,111.9,53.2,110.4,54.6Z"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M122.9,35.8l-.3-.4a18.507,18.507,0,0,0-1.9,3.7c-.2,1-.4,2.2-.4,2.2a17.34,17.34,0,0,1-.7,1.9c-.2.4-.4.9-.6,1.4a1.374,1.374,0,0,1-.4,1.2,2.389,2.389,0,0,0-.7,1.3s-1.9,1.9-3,1.9-4,.6-3.9,1.1-1.2.8-1.8.9,3.5,1.7,1.1,3.6c0,0,1.5.3,1.6.7s1.7-.2,1.7-.2a1.562,1.562,0,0,1,1.5-.8,2.523,2.523,0,0,0,1.7-.6,6.079,6.079,0,0,1,1.8-.9,12.684,12.684,0,0,0,1.5-.4c0-.1,3.8-16.6,3.8-16.6Z"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  className: "c47f4462-64b3-47af-a833-5e5444796067",
  d: "M122.9,35.8l-.3-.4a18.507,18.507,0,0,0-1.9,3.7c-.2,1-.4,2.2-.4,2.2a17.34,17.34,0,0,1-.7,1.9c-.2.4-.4.9-.6,1.4a1.374,1.374,0,0,1-.4,1.2,2.389,2.389,0,0,0-.7,1.3s-1.9,1.9-3,1.9-4,.6-3.9,1.1-1.2.8-1.8.9,3.5,1.7,1.1,3.6c0,0,1.5.3,1.6.7s1.7-.2,1.7-.2a1.562,1.562,0,0,1,1.5-.8,2.523,2.523,0,0,0,1.7-.6,6.079,6.079,0,0,1,1.8-.9,12.684,12.684,0,0,0,1.5-.4c0-.1,3.8-16.6,3.8-16.6Z"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M131.5,102.3a18.289,18.289,0,0,0-.6,2.5s-.6,2.6-4,1.9c0,0-2.3-.1-2.1-.9a2.614,2.614,0,0,1,.3-.8c.1-.2.2-.3.2-.5s.5-.7.6-1.1.2-.9.3-1.3a10.408,10.408,0,0,1,.6-2.2,5.637,5.637,0,0,1,.4-1.2l3.9,1s-.2,1,0,1.3a3.7,3.7,0,0,1,.5,1.1A.31.31,0,0,0,131.5,102.3Z"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M114.8,80.4a18.873,18.873,0,0,1,.9,3.4A2.663,2.663,0,0,1,116,85a4.012,4.012,0,0,0,.3,1.5l1.1,4a2.885,2.885,0,0,0,.3,1.8c.4.7.4.5.2,1.8a2.848,2.848,0,0,0,.9,2.9c.7.4-.3,1.3-.3,1.3s4.4,1.2,5.3.5-.5-4.3-.5-4.3c.1-1.2.1-2.3.1-3.5-.2-.4-.8-4.2-.8-4.2a4.567,4.567,0,0,1-.2-2c.2-.3-.1-1.1-.1-1.1s-.7-.9-.6-1.2a1.884,1.884,0,0,0-.2-.8s2-3,1.8-3.6a2.573,2.573,0,0,1,.1-1.5l.5-.9c.4-.6.8-1.4,1-1.6.3-.7.6-1.5.9-2.3l.2-.5a62,62,0,0,0,.6,6.2c.3,1.7.5,3.4.7,5.1a5.067,5.067,0,0,1,.2,1.3,25.009,25.009,0,0,0,.6,3.8,12.892,12.892,0,0,1,.1,2.8,38.435,38.435,0,0,0,0,4.8,4.708,4.708,0,0,0-1.3,1.5,9.638,9.638,0,0,0,0,2.4s3.1,1.5,4.4,1.1.8-2.7.8-2.7a9.494,9.494,0,0,0,.9-2.1l.3-2.4c1.2-2.1.7-7.4.9-7.8s-.4-2-.9-2.7a4.417,4.417,0,0,1,0-3.2c.3-.6-.3-2.5-.3-2.5a36.694,36.694,0,0,0,.5-4.3,18.917,18.917,0,0,1,.5-2.3s.5-.9.4-1.2.4-1,.2-1.3A3.922,3.922,0,0,1,135,66a11.626,11.626,0,0,0,.4-1.8c.1-.7.2-1.2.2-1.2l-3.2-2.6-7.9-2.1-3-1-2.9,4.6c-.2.3-.4.7-.6,1a3.259,3.259,0,0,0-.4,1.3,1.8,1.8,0,0,1-.3,1.2s-1.7,5.5-1.7,7a40.2,40.2,0,0,1-.6,5C115.1,77.6,114.4,79.8,114.8,80.4Z"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M126.5,35.9a4.773,4.773,0,0,0,1.1-4.4c0-.1,0-.1-.1-.2h-.3a4.7,4.7,0,0,1-4.7-4.7h0a5.853,5.853,0,0,1,.2-1.3,4.684,4.684,0,1,1,9,2.6c0,.1,0,.1-.1.2v.1c.6,1.4,1.4,3.1,2.1,3.5C135,32.4,126.6,35.9,126.5,35.9Z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M117.8,62.5a2.851,2.851,0,0,1,.8,1.4s2.3,1.6,2.1.6,1.2-5,1.2-5l-.2,5.5s7.4-.3,7.9-.9a17.251,17.251,0,0,1,3.7-1.6s2.7,2.2,3.2,2-.9-3.9-.9-3.9l-1.4-21.8s.4-6.5-.2-6.7a.215.215,0,0,1-.2-.2,2.353,2.353,0,0,1-.5-1.6c0-.7-1-.3-1-.3l.5.7L128,33.6h0l-.6-.3a2,2,0,0,0-1.3-.2,1.205,1.205,0,0,0-.5.5,3.1,3.1,0,0,0-.6,1.3l-1.7,2.9s-.9,3.9-.9,4a19.335,19.335,0,0,1-.6,4.1,5.759,5.759,0,0,0-.5,2.9,12.288,12.288,0,0,1-.2,2.7c-1.3,1-1.9,4.6-1.9,4.6L117,60.5A2.792,2.792,0,0,0,117.8,62.5Z"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  className: "8d7f3a60-86b4-40d0-a6ff-f2d7085c86eb",
  d: "M128.2,33.7a9.763,9.763,0,0,0,1.8,1.7l3.9-3.3a2.353,2.353,0,0,1-.5-1.6c0-.7-1-.3-1-.3l.1.1a.633.633,0,0,1-.1.9h-.1Z"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M128.2,33.6a9.763,9.763,0,0,0,1.8,1.7l3.9-3.3a2.353,2.353,0,0,1-.5-1.6c0-.7-1-.3-1-.3l.1.1a.633.633,0,0,1-.1.9h-.1Z"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  className: "8d7f3a60-86b4-40d0-a6ff-f2d7085c86eb",
  d: "M126.4,34.1c.5.6,1.2,1.3,1.2.9a3.694,3.694,0,0,1,.7-1.4,3.3,3.3,0,0,0-1.4,0C126.7,33.7,126.6,33.9,126.4,34.1Z"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M126.4,33.9c.5.6,1.2,1.3,1.2.9a2.134,2.134,0,0,1,.7-1.2,2,2,0,0,0-1.3-.2A1.024,1.024,0,0,0,126.4,33.9Z"
});

var _ref110 = /*#__PURE__*/React.createElement("circle", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  cx: 127.6,
  cy: 36.8,
  r: 0.3
});

var _ref111 = /*#__PURE__*/React.createElement("circle", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  cx: 125.3,
  cy: 45,
  r: 0.3
});

var _ref112 = /*#__PURE__*/React.createElement("circle", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  cx: 122.7,
  cy: 53.4,
  r: 0.3
});

var _ref113 = /*#__PURE__*/React.createElement("circle", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  cx: 122.6,
  cy: 62.6,
  r: 0.3
});

var _ref114 = /*#__PURE__*/React.createElement("circle", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  cx: 126.3,
  cy: 40.7,
  r: 0.3
});

var _ref115 = /*#__PURE__*/React.createElement("circle", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  cx: 124.2,
  cy: 49.2,
  r: 0.3
});

var _ref116 = /*#__PURE__*/React.createElement("circle", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  cx: 122.2,
  cy: 57.6,
  r: 0.3
});

var _ref117 = /*#__PURE__*/React.createElement("circle", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  cx: 122.6,
  cy: 63.6,
  r: 0.3
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  className: "8d7f3a60-86b4-40d0-a6ff-f2d7085c86eb",
  d: "M133.9,32.1s-.1-.5.6.3a8.961,8.961,0,0,0,1.9,1.5s2.8,2,3,2.9,1.1,4.9.6,6.2-4.2,7.7-4.2,7.7a3.223,3.223,0,0,1,.7,2.5,14.723,14.723,0,0,0-.4,3.6c.1.4-.2,1.4.3,1.8s.9,1-.5,1.8c0,0-.3.7,0,.8s-3.4,1.7-4.8.9-4-7.6-4.1-9.1a33.531,33.531,0,0,1,1.3-7.7c.5-1.2,1.8-5.8,2.4-6.8S133.9,32.1,133.9,32.1Z"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M134.1,32.1s-.1-.5.6.3a8.961,8.961,0,0,0,1.9,1.5s2.8,2,3,2.9,1.1,4.9.6,6.2-4.2,7.7-4.2,7.7a3.223,3.223,0,0,1,.7,2.5,14.723,14.723,0,0,0-.4,3.6c.1.4-.2,1.4.3,1.8s.9,1-.5,1.8c0,0-.3.7,0,.8s-3.4,1.7-4.8.9-4-7.6-4.1-9.1a33.531,33.531,0,0,1,1.3-7.7c.5-1.2,1.8-5.8,2.4-6.8S134.1,32.1,134.1,32.1Z"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  className: "8d7f3a60-86b4-40d0-a6ff-f2d7085c86eb",
  d: "M127.7,33s-1.4-.9-3.2,1.4c0,0-1.3.7-1.7.9s-.8,4.9-.8,4.9a8.662,8.662,0,0,0-.6,3.2c.2,1.2-.7,5.2-.7,5.2s-1.5,7.3-1.4,7.5a7.343,7.343,0,0,0,1.5-3.5,19.776,19.776,0,0,1,1.4-5.3c.2-.2,1.4-6.8,1.4-6.8a24.3,24.3,0,0,1,1.6-3.7,29.243,29.243,0,0,1,1.8-3,2.177,2.177,0,0,1,.8-.5Z"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M127.7,33s-1.6-.9-3.4,1.4c0,0-1.3.7-1.7.9s-.8,4.9-.8,4.9a8.662,8.662,0,0,0-.6,3.2c.2,1.2-.7,5.2-.7,5.2s-1.5,7.3-1.4,7.5a7.343,7.343,0,0,0,1.5-3.5,19.776,19.776,0,0,1,1.4-5.3c.2-.2,1.4-6.8,1.4-6.8a24.3,24.3,0,0,1,1.6-3.7,29.243,29.243,0,0,1,1.8-3,4.053,4.053,0,0,1,.9-.5Z"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M120.7,49s-3-2-4.5-1-3.9,2.4-1.5,3.4a15.218,15.218,0,0,0,5.6.8Z"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M124.1,102.9a22.542,22.542,0,0,1-3.6.6s-2.7.8-3.9,1-4,.1-4.2-.7a1.949,1.949,0,0,1-.1-.8,1.02,1.02,0,0,1,.5-.8,22.5,22.5,0,0,1,2.4-.8s1.3-.3,1.4-.8,1.9-2.1,1.9-2.1.2-1.1.5-1a2.41,2.41,0,0,1,1,1c.1.4,4.1-.4,4.1-.4a4.329,4.329,0,0,0,.1,1.6,5.462,5.462,0,0,1,.1,1.8v.1C124.2,101.6,124.9,102.5,124.1,102.9Z"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  className: "8d7f3a60-86b4-40d0-a6ff-f2d7085c86eb",
  d: "M122.8,25.4c.1,0,.1.1.2.1a1.689,1.689,0,0,0,1-.3c.3-.2.8-.3,1-.1.4.3.1,1,.5,1.3.2.2.6.1.9.3a1.235,1.235,0,0,1,.4.8c.1.3.2.7.5.8s.6-.1.9-.1h.2v-.1a4.1,4.1,0,0,1,.1-1.1.969.969,0,0,1,.8-.7c.5-.1,1,.4,1.3.8l.9,1.5v.1a4.7,4.7,0,1,0-8.6-3.8,4.329,4.329,0,0,0-.1.5Z"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M130.6,27c-.3-.4-.8-.9-1.3-.8a1.143,1.143,0,0,0-.8.7,4.1,4.1,0,0,0-.1,1.1v.1h-.2c-.3,0-.6.2-.9.1s-.4-.4-.5-.8a1.234,1.234,0,0,0-.4-.8c-.3-.2-.6-.1-.9-.3-.4-.3-.1-1-.5-1.3-.3-.3-.7-.1-1,.1a1.314,1.314,0,0,1-1,.3c-.1,0-.2-.1-.3-.1-.6-.2-1.3.2-1.8-.2a2.092,2.092,0,0,1-.4-.6c-.1-.3-.2-.6-.3-1a1.929,1.929,0,0,1,.3-1c.3-.4.8-.4,1.2-.7a3.45,3.45,0,0,0,.8-.9,1.765,1.765,0,0,1,.8-.9,1.09,1.09,0,0,1,1.1-.2c.1.1.2.1.4.2a.6.6,0,0,0,.4-.1,7.909,7.909,0,0,1,4.3-.3,4.711,4.711,0,0,1,1.7.4,2.211,2.211,0,0,1,1.2,1.3,6.753,6.753,0,0,0,.2,1.4c.1.3.3.6.4.9a4.234,4.234,0,0,1-.2,2.5,8.675,8.675,0,0,1-.5,2.8c-.1.2-.2.5-.4.4-.1-.1-.3-.6-.4-.7A4.8,4.8,0,0,0,130.6,27Z"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  className: "8d7f3a60-86b4-40d0-a6ff-f2d7085c86eb",
  d: "M139,41.9l.7,2s-1.6,6.1-2.4,7.4-1.9,2.9-1.9,2.9a6.45,6.45,0,0,1-4.1.5c-2.2-.4-8.6-1.6-8.6-1.6a.829.829,0,0,1-.8-.3c-.3-.4-1.7-.6-1.7-.6s-1.7-2.5.4-3.5c0,0,.3.6,1.4.2s1.4.3,1.4.3a8.834,8.834,0,0,0,2.8.2c1.3-.1,2.5-.2,3.7-.4a.446.446,0,0,1,.5,0,2.177,2.177,0,0,0,.8-.5c.2-.2.5.3.5.3s.4-.2.3-.5.3-1.2.3-1.2a4.868,4.868,0,0,0,.1-1.2,10.548,10.548,0,0,1,.6-2.4,2.768,2.768,0,0,0-.1-.9c-.1-.5,1-1.4,1-1.4s1.1-5.2,3.4-3.5A4.885,4.885,0,0,1,139,41.9Z"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  className: "1afa8d5e-158f-4e63-80d8-9508f26ca744",
  d: "M139.2,41l.7,2.3s-1.6,7-2.4,8.5-1.9,3.4-1.9,3.4a5.889,5.889,0,0,1-4.1.6c-2.2-.5-8.6-1.8-8.6-1.8a.735.735,0,0,1-.8-.4c-.3-.5-1.7-.7-1.7-.7s-1.7-2.8.4-4c0,0,.3.6,1.4.2s1.4.4,1.4.4a13.329,13.329,0,0,0,2.8.3c1.3-.1,2.5-.2,3.7-.4a.3.3,0,0,1,.4,0h0a2.177,2.177,0,0,0,.8-.5c.2-.3.5.3.5.3s.4-.2.3-.5a3.194,3.194,0,0,1,.3-1.4,5.7,5.7,0,0,0,.1-1.3,13.1,13.1,0,0,1,.6-2.7,4.1,4.1,0,0,0-.1-1.1c-.1-.5,1-1.6,1-1.6s1.1-6,3.4-4A5.156,5.156,0,0,1,139.2,41Z"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  className: "8d7f3a60-86b4-40d0-a6ff-f2d7085c86eb",
  d: "M130.2,49.8s.2,1.8,1.4,2.3S130.2,49.8,130.2,49.8Z"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  className: "8d7f3a60-86b4-40d0-a6ff-f2d7085c86eb",
  d: "M132.8,49.2c.1,0,1.8.9,1,1.5S132.8,49.2,132.8,49.2Z"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  className: "8d7f3a60-86b4-40d0-a6ff-f2d7085c86eb",
  d: "M132.9,47.9s2.5.5,1.7.9S132.9,47.9,132.9,47.9Z"
});

var _ref131 = /*#__PURE__*/React.createElement("polygon", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  points: "102.6 60.6 103.1 60.8 103 61.3 102.5 61.2 102.6 60.6"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M115.9,40.3a1.157,1.157,0,0,1,.7-.5c.2-.1.3-.1.5-.2l1-3.9a4.871,4.871,0,0,0-2.4-1.6c-2-.5-4,.3-4.4,1.9a2.272,2.272,0,0,0,.5,2.1c.2.2.4.5.6.7h0a1.209,1.209,0,0,1-.1,1.4L99.9,37,97.1,48a3.84,3.84,0,0,1,3.3-.7,4.224,4.224,0,0,1,2.7,5.3,4.169,4.169,0,0,1-4.7,2.8,3.677,3.677,0,0,1-2.5-2.2L93,64.5l11,2.8a3.7,3.7,0,0,1-.7-3.2,3.984,3.984,0,0,1,5-2.7,4.415,4.415,0,0,1,2.8,2.2l5.7-22.2-.8-.2A.642.642,0,0,1,115.9,40.3Z"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  className: "de9b19aa-f833-40be-ba57-711fe6902306",
  d: "M105.6,54.1a20.706,20.706,0,0,0,5,.5h.6l.8-1.5-.8-1.3s-.7-.2-1.6-.4c-1.4-.2-3.2-.4-4.1.1C103.9,52.4,104.1,53.5,105.6,54.1Z"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  d: "M110.5,54.6h.6l.8-1.5-.8-1.3s-.7-.2-1.6-.4C110.2,52,112,53.1,110.5,54.6Z"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  className: "0d6a080f-2586-440c-ba56-4ba040de1f07",
  d: "M123,35.7l-.3-.4a18.507,18.507,0,0,0-1.9,3.7c-.2,1-.4,2.2-.4,2.2a17.34,17.34,0,0,1-.7,1.9c-.2.4-.4.9-.6,1.4a1.374,1.374,0,0,1-.4,1.2A2.389,2.389,0,0,0,118,47s-1.9,1.9-3,1.9-4,.6-3.9,1.1-1.2.8-1.8.9,3.5,1.7,1.1,3.6c0,0,1.5.3,1.6.7s1.7-.2,1.7-.2a1.562,1.562,0,0,1,1.5-.8,2.523,2.523,0,0,0,1.7-.6,6.079,6.079,0,0,1,1.8-.9,12.684,12.684,0,0,0,1.5-.4c0-.1,3.8-16.6,3.8-16.6Z"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  className: "9a0534a5-8134-4af8-9396-61b61bd0fed3",
  d: "M123,35.7l-.3-.4a18.507,18.507,0,0,0-1.9,3.7c-.2,1-.4,2.2-.4,2.2a17.34,17.34,0,0,1-.7,1.9c-.2.4-.4.9-.6,1.4a1.374,1.374,0,0,1-.4,1.2A2.389,2.389,0,0,0,118,47s-1.9,1.9-3,1.9-4,.6-3.9,1.1-1.2.8-1.8.9,3.5,1.7,1.1,3.6c0,0,1.5.3,1.6.7s1.7-.2,1.7-.2a1.562,1.562,0,0,1,1.5-.8,2.523,2.523,0,0,0,1.7-.6,6.079,6.079,0,0,1,1.8-.9,12.684,12.684,0,0,0,1.5-.4c0-.1,3.8-16.6,3.8-16.6Z"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  className: "f217f3d6-36a0-4e2b-b8f4-1f103126ddc8",
  d: "M131.6,102.3a18.289,18.289,0,0,0-.6,2.5s-.6,2.6-4,1.9c0,0-2.3-.1-2.1-.9a2.614,2.614,0,0,1,.3-.8c.1-.2.2-.3.2-.5s.5-.7.6-1.1.2-.9.3-1.3a10.408,10.408,0,0,1,.6-2.2,5.637,5.637,0,0,1,.4-1.2l3.9,1s-.2,1,0,1.3a3.7,3.7,0,0,1,.5,1.1C131.6,102.2,131.6,102.2,131.6,102.3Z"
});

var _ref138 = /*#__PURE__*/React.createElement("rect", {
  className: "f2fde5c9-69d9-4232-8f17-82f65f251de5",
  x: 119.116,
  y: 40.216,
  width: 0.7,
  height: 0.6,
  transform: "translate(50.73 146.294) rotate(-75.718)"
});

var _ref139 = /*#__PURE__*/React.createElement("rect", {
  className: "f2fde5c9-69d9-4232-8f17-82f65f251de5",
  x: 117.292,
  y: 39.037,
  width: 0.7,
  height: 1.9,
  transform: "translate(49.869 144.128) rotate(-75.718)"
});

var _ref140 = /*#__PURE__*/React.createElement("rect", {
  className: "f2fde5c9-69d9-4232-8f17-82f65f251de5",
  x: 118.513,
  y: 40.006,
  width: 0.7,
  height: 0.7,
  transform: "translate(50.432 145.59) rotate(-75.718)"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M118.7,42.2l.3.1a.52.52,0,0,0,.4-.2h0l.3-1.1-.6-.1Z"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  className: "0240a6d2-d33a-460c-99cc-0d3a0d7fcade",
  d: "M118.4,42.1c-.2,0-.3-.2-.2-.4l.3-1.1-1.9-.5-5.7,22.2a3.607,3.607,0,0,1-1.2,4.7l-.1.5,2.5.6,6.6-26Z"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  className: "f2fde5c9-69d9-4232-8f17-82f65f251de5",
  d: "M118.2,41.7a.52.52,0,0,0,.2.4l.3.1.4-1.4-.7-.2Z"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M115.9,39a1.157,1.157,0,0,1,.7-.5c.2-.1.3-.1.5-.2l1-3.9a4.871,4.871,0,0,0-2.4-1.6c-2-.5-4,.3-4.4,1.9a2.272,2.272,0,0,0,.5,2.1c.2.2.4.5.6.7h0a1.209,1.209,0,0,1-.1,1.4L99.9,35.7l-2.8,11a3.84,3.84,0,0,1,3.3-.7,4.224,4.224,0,0,1,2.7,5.3,4.169,4.169,0,0,1-4.7,2.8,3.677,3.677,0,0,1-2.5-2.2L93,63.2,104,66a3.7,3.7,0,0,1-.7-3.2,3.984,3.984,0,0,1,5-2.7,4.415,4.415,0,0,1,2.8,2.2l5.7-22.2-.8-.2A.642.642,0,0,1,115.9,39Z"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  className: "f217f3d6-36a0-4e2b-b8f4-1f103126ddc8",
  d: "M116.8,39.5h0c0-.1-.1,0-.1,0Z"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M119.3,40.2l.6.1-.3,1.1h0c0,.2-.2.3-.4.2h0l-.3-.1Z"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  className: "dda50b30-c05c-471b-8c42-080ccf6b6199",
  d: "M119.2,40.2l-.4,1.4-6.6,26-2.5-.6.1-.5a3.634,3.634,0,0,0,1.2-4.7l5.7-22.2,1.8.5-.3,1.1.3-1.1.5.1-.5-.1-1.9-.5.2-.7,1.8.5.7.2.6.1-.2.7-.5-.2Z"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M118.6,36.6a2.56,2.56,0,0,1-1.5,1.7l1-3.9A3.567,3.567,0,0,1,118.6,36.6Z"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  className: "f217f3d6-36a0-4e2b-b8f4-1f103126ddc8",
  d: "M116.9,38.9h0c0-.1-.1,0-.1,0Z"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  className: "5fe0dbdb-4c8e-4ca4-9352-df6ba839b747",
  d: "M115,80.4a18.873,18.873,0,0,1,.9,3.4,2.663,2.663,0,0,1,.3,1.2,4.012,4.012,0,0,0,.3,1.5l1.1,4a2.885,2.885,0,0,0,.3,1.8c.4.7.4.5.2,1.8A2.848,2.848,0,0,0,119,97c.7.4-.3,1.3-.3,1.3s4.4,1.2,5.3.5-.5-4.3-.5-4.3c.1-1.2.1-2.3.1-3.5-.2-.4-.8-4.2-.8-4.2a4.567,4.567,0,0,1-.2-2c.2-.3-.1-1.1-.1-1.1s-.7-.9-.6-1.2a1.884,1.884,0,0,0-.2-.8s2-3,1.8-3.6a2.573,2.573,0,0,1,.1-1.5l.5-.9c.4-.6.8-1.4,1-1.6.3-.7.6-1.5.9-2.3l.2-.5a62,62,0,0,0,.6,6.2c.3,1.7.5,3.4.7,5.1a5.067,5.067,0,0,1,.2,1.3,25.008,25.008,0,0,0,.6,3.8,12.892,12.892,0,0,1,.1,2.8,38.435,38.435,0,0,0,0,4.8,4.708,4.708,0,0,0-1.3,1.5,9.638,9.638,0,0,0,0,2.4s3.1,1.5,4.4,1.1.8-2.7.8-2.7a9.494,9.494,0,0,0,.9-2.1l.3-2.4c1.2-2.1.7-7.4.9-7.8s-.4-2-.9-2.7a4.417,4.417,0,0,1,0-3.2c.3-.6-.3-2.5-.3-2.5a36.694,36.694,0,0,0,.5-4.3,18.917,18.917,0,0,1,.5-2.3s.5-.9.4-1.2.4-1,.2-1.3a3.922,3.922,0,0,1,.4-1.8,11.626,11.626,0,0,0,.4-1.8c.1-.7.2-1.2.2-1.2l-3.2-2.6-7.9-2.1-3-1-2.9,4.6c-.2.3-.4.7-.6,1a3.259,3.259,0,0,0-.4,1.3,1.8,1.8,0,0,1-.3,1.2s-1.7,5.5-1.7,7a40.2,40.2,0,0,1-.6,5C115.2,77.5,114.5,79.8,115,80.4Z"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  className: "fd634c6f-00c5-402a-b6d3-8be37c083f8b",
  d: "M126.6,35.9a4.773,4.773,0,0,0,1.1-4.4c0-.1,0-.1-.1-.2h-.3a4.7,4.7,0,0,1-4.7-4.7h0a5.853,5.853,0,0,1,.2-1.3,4.684,4.684,0,1,1,9,2.6c0,.1,0,.1-.1.2v.1c.6,1.4,1.4,3.1,2.1,3.5C135.1,32.4,126.8,35.9,126.6,35.9Z"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M118,62.5a2.851,2.851,0,0,1,.8,1.4s2.3,1.6,2.1.6,1.2-5,1.2-5L122,65s7.4-.3,7.9-.9a17.251,17.251,0,0,1,3.7-1.6s2.7,2.2,3.2,2-.9-3.9-.9-3.9l-1.4-21.8s.4-6.5-.2-6.7a.215.215,0,0,1-.2-.2,2.353,2.353,0,0,1-.5-1.6c0-.7-1-.3-1-.3l.5.7-4.8,2.9h0l-.6-.3a2,2,0,0,0-1.3-.2,1.205,1.205,0,0,0-.5.5,3.1,3.1,0,0,0-.6,1.3l-1.7,2.9s-.9,3.9-.9,4a19.335,19.335,0,0,1-.6,4.1,5.759,5.759,0,0,0-.5,2.9,12.288,12.288,0,0,1-.2,2.7c-1.3,1-1.9,4.6-1.9,4.6l-2.2,4.4A2.112,2.112,0,0,0,118,62.5Z"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  d: "M128.4,33.7a9.763,9.763,0,0,0,1.8,1.7l3.9-3.3a2.353,2.353,0,0,1-.5-1.6c0-.7-1-.3-1-.3l.1.1a.633.633,0,0,1-.1.9h-.1Z"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M128.4,33.6a9.763,9.763,0,0,0,1.8,1.7l3.9-3.3a2.353,2.353,0,0,1-.5-1.6c0-.7-1-.3-1-.3l.1.1a.633.633,0,0,1-.1.9h-.1Z"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  d: "M126.6,34.1c.5.6,1.2,1.3,1.2.9a3.694,3.694,0,0,1,.7-1.4,3.3,3.3,0,0,0-1.4,0A1.205,1.205,0,0,0,126.6,34.1Z"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  className: "49e7d872-cb34-474d-95dd-ff03667a30d7",
  d: "M126.5,33.8c.5.6,1.2,1.3,1.2.9a2.134,2.134,0,0,1,.7-1.2,2,2,0,0,0-1.3-.2C126.8,33.5,126.6,33.6,126.5,33.8Z"
});

var _ref157 = /*#__PURE__*/React.createElement("circle", {
  className: "f900f23f-ee25-4ff0-bfcd-36b6709d9d9f",
  cx: 127.8,
  cy: 36.7,
  r: 0.3
});

var _ref158 = /*#__PURE__*/React.createElement("circle", {
  className: "f900f23f-ee25-4ff0-bfcd-36b6709d9d9f",
  cx: 125.4,
  cy: 45,
  r: 0.3
});

var _ref159 = /*#__PURE__*/React.createElement("circle", {
  className: "f900f23f-ee25-4ff0-bfcd-36b6709d9d9f",
  cx: 122.8,
  cy: 53.4,
  r: 0.3
});

var _ref160 = /*#__PURE__*/React.createElement("circle", {
  className: "f900f23f-ee25-4ff0-bfcd-36b6709d9d9f",
  cx: 122.7,
  cy: 62.5,
  r: 0.3
});

var _ref161 = /*#__PURE__*/React.createElement("circle", {
  className: "f900f23f-ee25-4ff0-bfcd-36b6709d9d9f",
  cx: 126.4,
  cy: 40.6,
  r: 0.3
});

var _ref162 = /*#__PURE__*/React.createElement("circle", {
  className: "f900f23f-ee25-4ff0-bfcd-36b6709d9d9f",
  cx: 124.3,
  cy: 49.2,
  r: 0.3
});

var _ref163 = /*#__PURE__*/React.createElement("circle", {
  className: "f900f23f-ee25-4ff0-bfcd-36b6709d9d9f",
  cx: 122.3,
  cy: 57.5,
  r: 0.3
});

var _ref164 = /*#__PURE__*/React.createElement("circle", {
  className: "f900f23f-ee25-4ff0-bfcd-36b6709d9d9f",
  cx: 122.8,
  cy: 63.6,
  r: 0.3
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  d: "M134.1,32.1s-.1-.5.6.3a8.961,8.961,0,0,0,1.9,1.5s2.8,2,3,2.9,1.1,4.9.6,6.2-4.2,7.7-4.2,7.7a3.223,3.223,0,0,1,.7,2.5,14.723,14.723,0,0,0-.4,3.6c.1.4-.2,1.4.3,1.8s.9,1-.5,1.8c0,0-.3.7,0,.8s-3.4,1.7-4.8.9-4-7.6-4.1-9.1a33.531,33.531,0,0,1,1.3-7.7c.5-1.2,1.8-5.8,2.4-6.8S134.1,32.1,134.1,32.1Z"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  className: "71d05a25-099b-474b-9c77-f9119063bf09",
  d: "M134.2,32.1s-.1-.5.6.3a8.961,8.961,0,0,0,1.9,1.5s2.8,2,3,2.9,1.1,4.9.6,6.2-4.2,7.7-4.2,7.7a3.223,3.223,0,0,1,.7,2.5,14.723,14.723,0,0,0-.4,3.6c.1.4-.2,1.4.3,1.8s.9,1-.5,1.8c0,0-.3.7,0,.8s-3.4,1.7-4.8.9-4-7.6-4.1-9.1a33.531,33.531,0,0,1,1.3-7.7c.5-1.2,1.8-5.8,2.4-6.8S134.2,32.1,134.2,32.1Z"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  d: "M127.8,33s-1.4-.9-3.2,1.4c0,0-1.3.7-1.7.9s-.8,4.9-.8,4.9a8.662,8.662,0,0,0-.6,3.2c.2,1.2-.7,5.2-.7,5.2s-1.5,7.3-1.4,7.5a7.343,7.343,0,0,0,1.5-3.5,19.776,19.776,0,0,1,1.4-5.3c.2-.2,1.4-6.8,1.4-6.8a24.3,24.3,0,0,1,1.6-3.7,29.243,29.243,0,0,1,1.8-3,2.177,2.177,0,0,1,.8-.5Z"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  className: "71d05a25-099b-474b-9c77-f9119063bf09",
  d: "M127.8,33s-1.6-.9-3.4,1.4c0,0-1.3.7-1.7.9s-.8,4.9-.8,4.9a8.662,8.662,0,0,0-.6,3.2c.2,1.2-.7,5.2-.7,5.2s-1.5,7.3-1.4,7.5a7.343,7.343,0,0,0,1.5-3.5,19.776,19.776,0,0,1,1.4-5.3c.2-.2,1.4-6.8,1.4-6.8a24.3,24.3,0,0,1,1.6-3.7,29.243,29.243,0,0,1,1.8-3,4.053,4.053,0,0,1,.9-.5Z"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  className: "fd634c6f-00c5-402a-b6d3-8be37c083f8b",
  d: "M120.8,49s-3-2-4.5-1-3.9,2.4-1.5,3.4a15.218,15.218,0,0,0,5.6.8Z"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  className: "f217f3d6-36a0-4e2b-b8f4-1f103126ddc8",
  d: "M124.2,102.8a22.542,22.542,0,0,1-3.6.6s-2.7.8-3.9,1-4,.1-4.2-.7a1.949,1.949,0,0,1-.1-.8,1.02,1.02,0,0,1,.5-.8,22.5,22.5,0,0,1,2.4-.8s1.3-.3,1.4-.8,1.9-2.1,1.9-2.1.2-1.1.5-1a2.41,2.41,0,0,1,1,1c.1.4,4.1-.4,4.1-.4a4.329,4.329,0,0,0,.1,1.6,5.462,5.462,0,0,1,.1,1.8v.1C124.4,101.6,125,102.5,124.2,102.8Z"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  d: "M122.9,25.4c.1,0,.1.1.2.1a1.689,1.689,0,0,0,1-.3c.3-.2.8-.3,1-.1.4.3.1,1,.5,1.3.2.2.6.1.9.3a1.235,1.235,0,0,1,.4.8c.1.3.2.7.5.8s.6-.1.9-.1h.2v-.1a4.1,4.1,0,0,1,.1-1.1.969.969,0,0,1,.8-.7c.5-.1,1,.4,1.3.8l.9,1.5v.1a4.7,4.7,0,1,0-8.6-3.8,1.088,1.088,0,0,1-.1.5Z"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  className: "43cceecd-1668-4665-a83b-4c78a86a4cd0",
  d: "M130.7,26.9c-.3-.4-.8-.9-1.3-.8a1.143,1.143,0,0,0-.8.7,4.1,4.1,0,0,0-.1,1.1V28h-.2c-.3,0-.6.2-.9.1s-.4-.4-.5-.8a1.234,1.234,0,0,0-.4-.8c-.3-.2-.6-.1-.9-.3-.4-.3-.1-1-.5-1.3-.3-.3-.7-.1-1,.1a1.314,1.314,0,0,1-1,.3c-.1,0-.2-.1-.3-.1-.6-.2-1.3.2-1.8-.2a2.092,2.092,0,0,1-.4-.6c-.1-.3-.2-.6-.3-1a1.929,1.929,0,0,1,.3-1c.3-.4.8-.4,1.2-.7a3.45,3.45,0,0,0,.8-.9,1.765,1.765,0,0,1,.8-.9,1.09,1.09,0,0,1,1.1-.2c.1.1.2.1.4.2a.6.6,0,0,0,.4-.1,7.909,7.909,0,0,1,4.3-.3,4.711,4.711,0,0,1,1.7.4,2.211,2.211,0,0,1,1.2,1.3,6.753,6.753,0,0,0,.2,1.4c.1.3.3.6.4.9a4.234,4.234,0,0,1-.2,2.5,8.675,8.675,0,0,1-.5,2.8c-.1.2-.2.5-.4.4-.1-.1-.3-.6-.4-.7A5.071,5.071,0,0,0,130.7,26.9Z"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  d: "M139.2,41.9l.7,2s-1.6,6.1-2.4,7.4-1.9,2.9-1.9,2.9a6.45,6.45,0,0,1-4.1.5c-2.2-.4-8.6-1.6-8.6-1.6a.829.829,0,0,1-.8-.3c-.3-.4-1.7-.6-1.7-.6s-1.7-2.5.4-3.5c0,0,.3.6,1.4.2s1.4.3,1.4.3a8.834,8.834,0,0,0,2.8.2c1.3-.1,2.5-.2,3.7-.4a.446.446,0,0,1,.5,0,2.177,2.177,0,0,0,.8-.5c.2-.2.5.3.5.3s.4-.2.3-.5.3-1.2.3-1.2a4.868,4.868,0,0,0,.1-1.2,10.548,10.548,0,0,1,.6-2.4,2.768,2.768,0,0,0-.1-.9c-.1-.5,1-1.4,1-1.4s1.1-5.2,3.4-3.5A5.508,5.508,0,0,1,139.2,41.9Z"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  className: "0d6a080f-2586-440c-ba56-4ba040de1f07",
  d: "M139.3,41l.7,2.3s-1.6,7-2.4,8.5-1.9,3.4-1.9,3.4a5.889,5.889,0,0,1-4.1.6c-2.2-.5-8.6-1.8-8.6-1.8a.735.735,0,0,1-.8-.4c-.3-.5-1.7-.7-1.7-.7s-1.7-2.8.4-4c0,0,.3.6,1.4.2s1.4.4,1.4.4a13.329,13.329,0,0,0,2.8.3c1.3-.1,2.5-.2,3.7-.4a.3.3,0,0,1,.4,0h0a2.177,2.177,0,0,0,.8-.5c.2-.3.5.3.5.3s.4-.2.3-.5a3.194,3.194,0,0,1,.3-1.4,5.7,5.7,0,0,0,.1-1.3,13.1,13.1,0,0,1,.6-2.7,4.1,4.1,0,0,0-.1-1.1c-.1-.5,1-1.6,1-1.6s1.1-6,3.4-4A4.583,4.583,0,0,1,139.3,41Z"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  d: "M130.3,49.7s.2,1.8,1.4,2.3S130.3,49.7,130.3,49.7Z"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  d: "M132.9,49.1c.1,0,1.8.9,1,1.5S132.9,49.1,132.9,49.1Z"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  className: "ad60351f-e3bd-4b59-b16e-1fe3ccc2bbef",
  d: "M133,47.9s2.5.5,1.7.9S133,47.9,133,47.9Z"
});

var SvgMobile01 = function SvgMobile01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e2b30a23-5c41-4db1-aced-4a55dea8f486",
    "data-name": "Layer 1",
    viewBox: "0 0 163.3 110",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobile01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile-01.95ab17d7.svg";
export { ForwardRef as ReactComponent };